import css from './sass/style.scss';

require('./js/accordion')
require('./js/anims')
require('./js/carousels')
require('./js/fonts')
require('./js/glightbox')
require('./js/init')
require('./js/map')
require('./js/nav')
require('./js/polyfills')
require('./js/scrollpos')
require('./js/smoothscroll')